var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"big-box"},[(_vm.type == 0 )?_c('list',{attrs:{"notice":_vm.noticeObj}}):_vm._e(),(_vm.type == 1 )?_c('navigationList',{attrs:{"notice":_vm.noticeObj},on:{"handlerCrumbs":_vm.handlerCrumbs}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }